<template>
    <div
        class="max-w-7xl mx-auto flex flex-col gap-[30px] rounded-[20px] p-[13px] laptop:p-[20px] shadow-custom bg-[#fff]">
        <div class="px-[50px] 2xl:px-0 relative text-center flex flex-col gap-0 2xl:gap-[7px]">
            <h1 class="m-0 font-lato font-bold text-[25px] text-[#092E87]">Quote Invoices</h1>
            <p class="m-0 font-lato font-normal text-[16px] text-[#666]">View and manage all quote-related invoices in
                one place.</p>
            <button v-if="$route.query.is_from_mobile != '1'" @click="backClicked()"
                class="lg:hidden absolute top-0 left-0 translate-y-1/2 flex items-center justify-center w-[30px] h-[30px] rounded-full shadow-[0px_0px_10px_0px_#00000026]">
                <img src="../../assets/images/blue-back-icon.svg" alt="Arrow Icon" class="w-[14px] h-auto">
            </button>
        </div>
        <div v-if="!loading"
            class="flex mobile:flex-wrap laptop:flex-nowrap items-start gap-[20px] rounded-[15px] p-[10px] laptop:p-[15px] border border-[#ccc]">
            <div
                class="w-full laptop:w-[25%] flex flex-wrap laptop:flex-col gap-[10px] laptop:gap-[15px] rounded-[15px] p-[20px] bg-[#092E87]">
                <!-- <div class="flex flex-col gap-[3px] w-[32%] laptop:w-full">
                    <h6 class="m-0 font-lato font-normal text-[14px] text-[#fff]">Quote ID:</h6>
                    <h3 class="m-0 font-lato font-normal text-[18px] tablet:text-[22px] laptop:text-[30px] text-[#fff]">
                        {{ invoiceList.quote_id }}</h3>
                </div>
                <div class="flex flex-col gap-[3px] w-[62%] laptop:w-full">
                    <h6 class="m-0 font-lato font-normal text-[14px] text-[#fff]">Quote Type:</h6>
                    <h3 class="m-0 font-lato font-normal text-[18px] tablet:text-[22px] laptop:text-[30px] text-[#fff]">
                        {{ invoiceList.type
                        }}
                    </h3>
                </div> -->
                <div class="flex justify-between tablet:flex-col gap-[3px] w-full">
                    <h6 class="m-0 font-lato font-normal text-[14px] text-[#fff]">Job Total:</h6>
                    <h3 class="m-0 font-lato font-normal text-[18px] tablet:text-[22px] laptop:text-[30px] text-[#fff]">
                        ${{ $helper.formatAmount(invoiceList.job_total) }}</h3>
                </div>
                <div class="flex justify-between tablet:flex-col gap-[3px] w-full">
                    <h6 class="m-0 font-lato font-normal text-[16px] laptop:text-[18px] text-[#4EFF00]">Paid amount:
                    </h6>
                    <h3 class="m-0 font-lato font-normal text-[18px] tablet:text-[22px] laptop:text-[30px] text-[#fff]">
                        ${{ $helper.formatAmount(invoiceList.paid) }}</h3>
                </div>
                <div class="flex justify-between tablet:flex-col gap-[3px] w-full">
                    <h6 class="m-0 font-lato font-normal text-[16px] laptop:text-[18px] text-[#FE5000]">Outstanding
                        amount:</h6>
                    <h3 class="m-0 font-lato font-normal text-[18px] tablet:text-[22px] laptop:text-[30px] text-[#fff]">
                        ${{ $helper.formatAmount(invoiceList.outstanding) }}</h3>
                </div>
                <!-- <div class="flex flex-col gap-[3px] w-[62%] laptop:w-full">
                    <h6 class="m-0 font-lato font-normal text-[14px] text-[#fff]">Invoice Total:</h6>
                    <h3 class="m-0 font-lato font-normal text-[18px] tablet:text-[22px] laptop:text-[30px] text-[#fff]">
                        ${{
                            $helper.formatAmount(invoiceList.invoices_total) }}</h3>
                </div> -->
            </div>
            <div class="w-full laptop:w-[75%] flex flex-col gap-[20px]">
                <div class="relative laptop:ml-auto flex justify-center laptop:justify-end">
                    <button @click="addInvoiceModalClick()"
                        class="relative z-[1] group flex items-center gap-[5px] rounded-full p-[5px] pr-[10px] border-[1px] border-[#CCCCCC] bg-gradient-to-r from-[#FFFFFF] to-[#F1F1F1] hover:border-[#FE5000] hover:bg-none hover:from-transparent hover:to-transparent hover:!bg-[#FE5000]">
                        <img src="../../assets/images/plus-orange-circle-icon.svg" alt="Button Icon"
                            class="w-[30px] h-[30px] object-cover group-hover:hidden">
                        <img src="../../assets/images/plus-white-circle-icon.svg" alt="Button Icon"
                            class="w-[30px] h-[30px] object-cover hidden group-hover:block">
                        <span class="font-lato text-[14px] text-[#333] group-hover:text-[#fff]">Add
                            New Invoice</span>
                    </button>
                    <div class="absolute top-[20px] left-0 w-full laptop:hidden border-top border-[#EFEFEF]"></div>
                </div>

                <div
                    class="flex gap-[7px] tablet:gap-[10px] p-[10px] tablet:p-[15px] rounded-[7px] tablet:rounded-[10px] border-[1px] border-[#EFEFEF] bg-[#EFEFEF]/20">
                    <p class="m-0 font-lato font-bold text-[13px] tablet:text-[14px] leading-[1] text-[#666]">Quote ID:
                        <span class="text-[#FE5000]">{{ invoiceList.quote_id }}</span></p>
                    <div class="w-[2px] h-auto bg-[#CCCCCC]"></div>
                    <p class="m-0 font-lato font-bold text-[13px] tablet:text-[14px] leading-[1] text-[#666]">Quote
                        Type: <span class="text-[#092E87]">{{ invoiceList.type }}</span></p>
                </div>

                <div v-if="invoiceList.list.length" class="flex flex-col gap-[40px] laptop:gap-[20px]">
                    <!-- Mobile View -->
                    <div v-for="(value, index) in invoiceList.list" :key="value.id || index"
                        class="laptop:hidden relative flex flex-col gap-[10px] rounded-[20px] px-[15px] py-[20px] shadow-[0px_0px_10px_0px_#00000026]">
                        <div class="flex items-start justify-between w-full">
                            <div>
                                <p class="m-0 font-lato text-[14px] font-normal text-[#999]">ID:</p>
                                <p class="m-0 font-lato text-[14px] font-normal text-[#7286D3]">{{ value.id }}</p>
                            </div>
                            <div>
                                <p class="m-0 font-lato text-[14px] font-normal text-[#999]">Payment Type:</p>
                                <p class="m-0 font-lato text-[14px] font-normal text-[#333333]">{{ value.payment_type }}
                                </p>
                            </div>
                            <div>
                                <p class="m-0 font-lato text-[14px] font-normal text-[#999]">Amount:</p>
                                <p class="m-0 font-lato text-[14px] font-normal text-[#333333]">${{
                                    $helper.formatAmount(value.amount) }}</p>
                            </div>
                        </div>
                        <div class="2xl:hidden border-top border-[#EFEFEF]"></div>
                        <div class="flex items-start justify-between w-full">
                            <div>
                                <p class="m-0 font-lato text-[14px] font-normal text-[#999]">Created Datetime:</p>
                                <p class="m-0 font-lato text-[14px] font-normal text-[#333]">
                                    {{ value.date != null &&
                                        value.date !== ''
                                        ? $helper.formatDateTime(value.date)
                                        : '-' }}
                                </p>
                            </div>
                            <div>
                                <p class="m-0 font-lato text-[14px] font-normal text-[#999]">Paid Date:</p>
                                <p class="m-0 font-lato text-[14px] font-normal text-[#333333]">
                                    {{ value.paid_date != null &&
                                        value.paid_date !== ''
                                        ? $helper.formattedDate(value.paid_date)
                                        : '-' }}
                                </p>
                            </div>
                        </div>
                        <div class="absolute -top-[20px] right-[15px] flex items-center justify-end gap-[10px]">
                            <div
                                class="relative z-[1] group flex items-center gap-[5px] rounded-full px-[10px] py-[5px] border-[1px] border-[#CCCCCC] bg-gradient-to-r from-[#FFFFFF] to-[#F1F1F1]">
                                <div class="flex items-center gap-[10px]">
                                    <p class="m-0 font-lato text-[14px] font-normal text-[#999]">Status:</p>
                                    <p v-if="value?.status == 'Paid'"
                                        class="w-max m-0 px-[10px] py-[2px] rounded-full font-lato text-[12px] font-normal text-[#fff] bg-[#65B741]">
                                        {{ value.status }}</p>
                                    <p v-else-if="value?.status == 'Unpaid'"
                                        class="w-max m-0 px-[10px] py-[2px] rounded-full font-lato text-[12px] font-normal text-[#fff] bg-[#F59E0B]">
                                        {{ value.status }}</p>
                                    <p v-else
                                        class="w-max m-0 px-[10px] py-[2px] rounded-full font-lato text-[12px] font-normal text-[#fff] bg-[#0284C7]">
                                        {{ value.status }}</p>
                                </div>
                            </div>
                            <div class="dropdown h-[30px]">
                                <button class="outline-none border-0 !p-0" type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <img src="../../assets/images/blue-ellipse-button-icon.svg" alt="button icon"
                                        class="w-[30px] h-[30px] object-cover">
                                </button>
                                <ul class="dropdown-menu group-list bg-[#fff] border-0 !p-[10px] overflow-hidden shadow-[0px_0px_10px_0px_#00000026]"
                                    aria-labelledby="dropdownMenuButton1">
                                    <li v-if="value?.status == 'Unpaid'">
                                        <button @click="payNowClicked(value)"
                                            class="dropdown-item !rounded-[5px] hover:!text-[#fff] hover:!bg-[#FE5000]">Pay
                                            Now</button>
                                    </li>
                                    <li v-if="value?.status == 'Unpaid'">
                                        <button @click="editClicked(value)"
                                            class="dropdown-item !rounded-[5px] hover:!text-[#fff] hover:!bg-[#FE5000]">Edit</button>
                                    </li>
                                    <!-- v-if="value?.status == 'Paid'" -->
                                    <li>
                                        <button @click="downloadClicked(value)"
                                            class="dropdown-item !rounded-[5px] hover:!text-[#fff] hover:!bg-[#FE5000]">Detail</button>
                                    </li>
                                    <li v-if="value?.status == 'Unpaid'">
                                        <button @click="shareClicked(value)"
                                            class="dropdown-item !rounded-[5px] hover:!text-[#fff] hover:!bg-[#FE5000]">Share</button>
                                    </li>
                                    <li v-if="value?.status == 'Unpaid'">
                                        <button @click="voidClicked(value)"
                                            class="dropdown-item !rounded-[5px] hover:!text-[#fff] hover:!bg-[#FE5000]">Void</button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Desktop View -->
                    <div v-for="(value, index) in invoiceList.list" :key="value.id || index"
                        class="hidden laptop:flex gap-[10px] rounded-[10px] p-[10px] shadow-[0px_0px_10px_0px_#00000026]">
                        <div class="w-[10%]">
                            <p class="m-0 font-lato text-[14px] font-normal text-[#999]">ID:</p>
                            <p class="m-0 font-lato text-[16px] font-normal text-[#7286D3]">{{ value.id }}</p>
                        </div>
                        <div class="w-[10%]">
                            <p class="m-0 font-lato text-[14px] font-normal text-[#999]">Amount:</p>
                            <p class="m-0 font-lato text-[16px] font-normal text-[#333333]">${{
                                $helper.formatAmount(value.amount) }}</p>
                        </div>
                        <div class="w-[15%]">
                            <p class="m-0 font-lato text-[14px] font-normal text-[#999]">Payment Type:</p>
                            <p class="m-0 font-lato text-[16px] font-normal text-[#333333]">{{ value.payment_type }}</p>
                        </div>
                        <div class="w-[20%]">
                            <p class="m-0 font-lato text-[14px] font-normal text-[#999]">Created Datetime:</p>
                            <p class="m-0 font-lato text-[16px] font-normal text-[#333333]">
                                {{ value.date != null &&
                                    value.date !== ''
                                    ? $helper.formatDateTime(value.date)
                                    : '-' }}
                            </p>
                        </div>
                        <div class="w-[25%]">
                            <p class="m-0 font-lato text-[14px] font-normal text-[#999]">Paid Date:</p>
                            <p class="m-0 font-lato text-[16px] font-normal text-[#333333]">
                                {{ value.paid_date != null &&
                                    value.paid_date !== ''
                                    ? $helper.formattedDate(value.paid_date)
                                    : '-' }}
                            </p>
                        </div>
                        <div class="w-[10%]">
                            <p class="m-0 font-lato text-[14px] font-normal text-[#999]">Status:</p>
                            <p v-if="value?.status == 'Paid'"
                                class="w-max m-0 px-[5px] py-[2px] rounded-[3px] font-lato text-[12px] font-normal text-[#fff] bg-[#65B741]">
                                {{ value.status }}</p>
                            <p v-else-if="value?.status == 'Unpaid'"
                                class="w-max m-0 px-[5px] py-[2px] rounded-[3px] font-lato text-[12px] font-normal text-[#fff] bg-[#F59E0B]">
                                {{ value.status }}</p>
                            <p v-else
                                class="w-max m-0 px-[5px] py-[2px] rounded-[3px] font-lato text-[12px] font-normal text-[#fff] bg-[#0284C7]">
                                {{ value.status }}</p>
                        </div>
                        <div class="w-[10%] flex justify-center items-center">
                            <div class="dropdown h-[30px]">
                                <button class="outline-none border-0 !p-0" type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <img src="../../assets/images/blue-ellipse-button-icon.svg" alt="button icon"
                                        class="w-[30px] h-[30px] object-cover">
                                </button>
                                <ul class="dropdown-menu group-list bg-[#fff] border-0 !p-[10px] overflow-hidden shadow-[0px_0px_10px_0px_#00000026]"
                                    aria-labelledby="dropdownMenuButton1">
                                    <li v-if="value?.status == 'Unpaid'">
                                        <button @click="payNowClicked(value)"
                                            class="dropdown-item !rounded-[5px] hover:!text-[#fff] hover:!bg-[#FE5000]">Pay
                                            Now</button>
                                    </li>
                                    <li v-if="value?.status == 'Unpaid'">
                                        <button @click="editClicked(value)"
                                            class="dropdown-item !rounded-[5px] hover:!text-[#fff] hover:!bg-[#FE5000]">Edit</button>
                                    </li>
                                    <!-- v-if="value?.status == 'Paid'" -->
                                    <li>
                                        <button @click="downloadClicked(value)"
                                            class="dropdown-item !rounded-[5px] hover:!text-[#fff] hover:!bg-[#FE5000]">Detail</button>
                                    </li>
                                    <li v-if="value?.status == 'Unpaid'">
                                        <button @click="shareClicked(value)"
                                            class="dropdown-item !rounded-[5px] hover:!text-[#fff] hover:!bg-[#FE5000]">Share</button>
                                    </li>
                                    <li v-if="value?.status == 'Unpaid'">
                                        <button @click="voidClicked(value)"
                                            class="dropdown-item !rounded-[5px] hover:!text-[#fff] hover:!bg-[#FE5000]">Void</button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else class="flex items-center justify-center laptop:h-[200px]">
                    <p class="m-0 font-lato  text-center text-[16px] laptop:text-[20px] text-[#666666]">No Invoice
                        Available</p>
                </div>
            </div>
        </div>
        <button v-if="is_from_mobile == 0" @click="backClicked()"
            class="block w-max mx-auto font-lato text-[16px] px-[40px] py-[5px] rounded-full text-[#092E87] border-[1px] border-[#092E87] hover:bg-[#092E87] hover:text-[#fff]">Back</button>
    </div>

    <addInvoiceModal ref="addInvoiceModal"  @success="handleInvoiceSuccess" />
    <viewInvoiceDetailModal ref="viewInvoiceDetailModal" :invoiceDetail="selectedInvoice" />
    <shareInvoiceModal ref="shareInvoiceModal" :invoiceDetail="selectedInvoice" />
    <voidModal ref="voidModal" @success="updateInvoiceList" />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import addInvoiceModal from "../../components/invoice/addInvoiceModal.vue";
import viewInvoiceDetailModal from "../../components/invoice/viewInvoiceDetailModal.vue";
import shareInvoiceModal from "../../components/invoice/shareInvoiceModal.vue";
import voidModal from "../../components/invoice/voidModal.vue";

export default {
    data() {
        return {
            loading: true,
            invoiceItemList: [],
            selectedInvoice: null,
            is_from_mobile: localStorage.getItem("is_from_mobile", 0) ?? 0
        }
    },

    components: {
        addInvoiceModal,
        viewInvoiceDetailModal,
        shareInvoiceModal,
        voidModal
    },

    computed: {
        ...mapGetters(["invoiceList"]),
    },

    watch: {
        invoiceList: function () {
            this.loading = false
        },
    },

    mounted() {
        this.getInvoiceList({
            job_type: 'sar',
            job_id: this.$route.params.id,
        })
    },

    methods: {
        ...mapActions(["getInvoiceList"]),

        addInvoiceModalClick() {
            this.$refs.addInvoiceModal.show('create' , this.invoiceList)
        },

        payNowClicked(value) {

            localStorage.setItem("redirect_to", "job_invoice")
            this.$router.push({
                path: `/checkout/invoice/${value.id}`,
                query: {
                    is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
                }
            });
        },

        editClicked(value) {
            this.$refs.addInvoiceModal.show('edit', value)
        },

        downloadClicked(value) {
            // alert(this.$route.params.id)
            this.$router.push({
                path: `/invoice/${value.id}`,
                query: {
                    is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
                }
            });
        },

        shareClicked(invoice) {
            this.selectedInvoice = invoice;
            this.$nextTick(() => {
                this.$refs.shareInvoiceModal.show(invoice);
            });
        },

        detailClicked(invoice) {
            this.selectedInvoice = invoice;
            this.$nextTick(() => {
                this.$refs.viewInvoiceDetailModal.show();
            });
        },

        voidClicked(value) {
            this.$refs.voidModal.show(value.id)
        },

        backClicked() {
            this.$router.go(-1);
        },

        handleInvoiceSuccess(payload) {
            if (payload && payload.invoiceItems) {
                this.invoiceItemList = payload.invoiceItems;
            }
            this.getInvoiceList({
                job_type: 'sar',
                job_id: this.$route.params.id
            });
        },

        updateInvoiceList() {
            this.getInvoiceList({
                job_type: 'sar',
                job_id: this.$route.params.id
            })
        }
    },
}

</script>